/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-var-requires */
import { some } from 'lodash'
import type { MakeRequestOptions } from '..'
import { MAKE_REQUEST_PENDING } from '@src/constants/events'
import GlobalEvents from '@src/utils/custom.event'

const requestDict = {}

export interface HandlePendingOptions<T> {
  requestFetchUID: string
  isPending: boolean
  makeRequestOptions: MakeRequestOptions<T>
}

export function handlePending<T>({
  requestFetchUID,
  isPending,
  makeRequestOptions
}: HandlePendingOptions<T>) {
  if (!makeRequestOptions?.pendingStatus) {
    return null
  }

  if (isPending) {
    GlobalEvents.dispatch(MAKE_REQUEST_PENDING, { isPending: true })
    requestDict[requestFetchUID] = true
  } else {
    delete requestDict[requestFetchUID]
    const hasRequestPending = some(requestDict, q => !!q)
    if (!hasRequestPending) {
      GlobalEvents.dispatch(MAKE_REQUEST_PENDING, { isPending: false })
    }
  }
}
